class MenuPlugin {
    constructor(Vue, $router) {
        this.$router = $router;

        const vm = this.initVm(Vue);
        this.bindRouterEvents();

        return {
            toggle: this.toggle.bind(this),
            close: this.close.bind(this),
            open: this.open.bind(this),
            get isOpen() {
                return vm.isOpen;
            }
        };
    }

    /**
     * Initialize Vue instance to make data binding possible
     * without having to provide a VueX store instance.
     *
     * @param   {Object}  Vue  Vue object as passed to the plugin
     *
     * @return  {void}
     */
    initVm(Vue) {
        this.menuVm = new Vue({
            data() {
                return {
                    isOpen: false
                };
            }
        });

        return this.menuVm;
    }

    /**
     * Close the menu after each route change
     *
     * @return  {void}
     */
    bindRouterEvents() {
        this.$router.afterEach(() => {
            // Close the menu overlay
            this.close();
        });
    }

    close() {
        this.menuVm.isOpen = false;

        if (!process.server) {
            // Remove body data attributes, as the dn-modal is always present
            // for compatibility with static rendering.
            document.body.removeAttribute('data-modal-open');
            document.body.removeAttribute('data-prevent-scrolling');
        }
    }

    open() {
        this.menuVm.isOpen = true;

        if (!process.server) {
            // Add body data attributes, as the dn-modal is always present
            // for compatibility with static rendering.
            document.body.setAttribute('data-modal-open', 'true');
            document.body.setAttribute('data-prevent-scrolling', 'true');
        }
    }

    toggle() {
        this.menuVm.isOpen = !this.menuVm.isOpen;
    }

    get isOpen() {
        return this.menuVm.isOpen;
    }
}

export default {
    install(VueInstance, VueRouter) {
        VueInstance.prototype.$menu = VueInstance.$menu = new MenuPlugin(VueInstance, VueRouter);
    }
};
